import { useEffect, useRef, useState } from "react";
import { CheckCircleIcon, FlagIcon, WarningCircleIcon, XIcon } from "@phosphor-icons/react";
import { sanitizarTexto } from "@encuentrayayuda/shared/lib/sanitizar";
import { api } from "./lib/api.js";

const MOTIVOS = [
  ["INFORMACION_FALSA", "Información falsa o engañosa"],
  ["CONTENIDO_INAPROPIADO", "Contenido inapropiado"],
  ["ESTAFA_SUPLANTACION", "Posible estafa o suplantación"],
  ["REPORTE_DUPLICADO", "El anuncio está duplicado"],
  ["RIESGO_SEGURIDAD", "Puede poner a alguien en riesgo"],
  ["OTRO", "Otro motivo"],
];

export default function ReportarAnuncioModal({ entidad, reporteId, onClose }) {
  const [motivo, setMotivo] = useState("");
  const [detalle, setDetalle] = useState("");
  const [estado, setEstado] = useState("formulario");
  const [error, setError] = useState("");
  const tituloRef = useRef(null);

  useEffect(() => {
    function cerrar(evento) {
      if (evento.key === "Escape" && estado !== "enviando") onClose();
    }
    document.body.classList.add("modal-open", "report-listing-modal-open");
    document.addEventListener("keydown", cerrar);
    tituloRef.current?.focus();
    return () => {
      document.body.classList.remove("modal-open", "report-listing-modal-open");
      document.removeEventListener("keydown", cerrar);
    };
  }, [estado, onClose]);

  async function enviar(evento) {
    evento.preventDefault();
    setError("");
    const detalleLimpio = sanitizarTexto(detalle);
    if (!motivo) return setError("Selecciona por qué quieres reportar este anuncio.");
    if (motivo === "OTRO" && detalleLimpio.length < 10) return setError("Explica el motivo en al menos 10 caracteres.");

    setEstado("enviando");
    try {
      await api.denuncias.crear({ entidad: entidad.toUpperCase(), reporteId, motivo, detalle: detalleLimpio });
      setEstado("enviado");
    } catch (err) {
      setError(err.message || "No pudimos enviar la denuncia. Intenta nuevamente.");
      setEstado("formulario");
    }
  }

  return <div className="report-listing-modal" role="dialog" aria-modal="true" aria-labelledby="report-listing-title">
    <div className="report-listing-modal__card">
      <button className="report-listing-modal__close" type="button" onClick={onClose} disabled={estado === "enviando"} aria-label="Cerrar"><XIcon weight="bold" /></button>
      {estado === "enviado" ? <div className="report-listing-success">
        <CheckCircleIcon weight="fill" />
        <h2 id="report-listing-title" tabIndex="-1" ref={tituloRef}>Recibimos tu reporte</h2>
        <p>Nuestro equipo revisará el anuncio. Gracias por ayudar a mantener segura la comunidad.</p>
        <button type="button" onClick={onClose}>Entendido</button>
      </div> : <form onSubmit={enviar}>
        <span className="report-listing-modal__icon"><FlagIcon weight="fill" /></span>
        <h2 id="report-listing-title" tabIndex="-1" ref={tituloRef}>Reportar este anuncio</h2>
        <p>Cuéntanos qué ocurre. La persona que publicó el anuncio no verá quién lo reportó.</p>
        <fieldset disabled={estado === "enviando"}><legend>¿Por qué quieres reportarlo?</legend>{MOTIVOS.map(([valor, etiqueta]) => <label className={motivo === valor ? "is-selected" : ""} key={valor}><input type="radio" name="motivo" value={valor} checked={motivo === valor} onChange={(e) => setMotivo(e.target.value)} /><span>{etiqueta}</span></label>)}</fieldset>
        <label className="report-listing-modal__detail" htmlFor="report-detail">Información adicional {motivo === "OTRO" ? "(obligatoria)" : "(opcional)"}</label>
        <textarea id="report-detail" maxLength="500" value={detalle} onChange={(e) => setDetalle(e.target.value)} placeholder="Describe brevemente lo que encontraste…" disabled={estado === "enviando"} />
        <small className="report-listing-modal__counter">{detalle.length}/500</small>
        {error && <p className="report-listing-modal__error" role="alert"><WarningCircleIcon weight="fill" />{error}</p>}
        <div className="report-listing-modal__actions"><button type="button" onClick={onClose} disabled={estado === "enviando"}>Cancelar</button><button type="submit" disabled={estado === "enviando"}><FlagIcon weight="bold" />{estado === "enviando" ? "Enviando…" : "Enviar reporte"}</button></div>
      </form>}
    </div>
  </div>;
}
